import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useTabs } from '@shared/hooks';
import { AccountType } from '@shared/api';
import { StatementPaymentTab, StatementsCardTab } from './widgets';
import { PageContainer } from '@widgets';
import { NoData, Spinner, Tabs } from '@shared/widgets';

export const StatementsPage = () => {
  const tabsState = useTabs();

  const { t } = useTranslation('statements');

  const currentTabView = useMemo(() => {
    if (tabsState.loading) return <Spinner />;
    if (tabsState.tab === AccountType.Payment) return <StatementPaymentTab />;
    else if (tabsState.tab === AccountType.Card) return <StatementsCardTab />;
    else return <NoData />;
  }, [tabsState.loading, tabsState.tab]);
  return (
    <PageContainer title={t('title')} header={t('header')}>
      {!tabsState.loading && tabsState.hasCard && tabsState.hasPayment && (
        <Tabs className='mb-6' options={tabsState.tabs} value={tabsState.tab!} onChange={tabsState.onChangeTab} />
      )}
      {currentTabView}
    </PageContainer>
  );
};
